<!-- Skip to main content (WCAG 2.4.1) -->
<a href="#main-content" class="skip-link">{{ 'common.skipToMain' | transloco }}</a>

<!-- Loading bar (PFL-1679: this layout hosts guest/auth screens with no
     MetricSurface widgets, so keep the global bar working for their HTTP
     calls — FuseLoadingService._auto$ is a singleton BehaviorSubject, so an
     unbound bar would silently inherit whatever the shell layout last set) -->
<fuse-loading-bar [autoMode]="true"></fuse-loading-bar>

<!-- Wrapper -->
<div class="flex w-full flex-auto flex-col">
    <!-- Content -->
    <main id="main-content" class="flex flex-auto flex-col">
        
        @if (true) {
            <router-outlet></router-outlet>
        }
    </main>
</div>
